<template>
  <v-data-table
    :headers="headers"
    :items="recenttransactions.allTransactions"
    hide-default-footer
  >
    <template v-slot:no-data>
      <v-container fluid class="text-center">
        <p>No data available</p>
      </v-container>
    </template>
    <template v-slot:item.updated_at="{ item }">
      {{ formatMySQLDate(item?.updated_at) }}
    </template>

    <template v-slot:item.amount="{ item }">
      $ {{ item?.amount.toFixed(2) }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-icon small :class="verifyIcon(item?.status)"></v-icon>
      {{ item?.status }}
    </template>

    <template v-slot:item.trx_type="{ item }">
      {{ item?.trx_type || "Internal Transfer" }}
    </template>

    <template v-slot:item.acc_no="{ item }">
      {{ item?.acc_no || item?.from_acc_no || "N/A" }}
    </template>

    <!-- <template v-slot:item.acc_type="{ item }">
      {{ item?.acc_type || item?.from_acc_type || "N/A" }}
    </template> -->

    <template v-slot:item.transaction_fee="{ item }">
      $ {{
        item?.transaction_fee === 0
          ? 0.0
          : !item?.transaction_fee
          ? "N/A"
          : item?.transaction_fee
      }}
    </template>

    <template v-slot:item.net_amount="{ item }">
     $ {{
        item?.net_amount === 0
          ? 0
          : !item?.net_amount
          ? "N/A"
          : item?.net_amount?.toFixed(2)
      }}
    </template>

    <!-- <template v-slot:item.detail="{ item }">
      <router-link class="links text-decoration-none" to="/">
        <v-icon small> mdi-eye </v-icon>
      </router-link>
    </template> -->
  </v-data-table>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRANSACTION__ACTIONS } from "@/store/action-types";

export default {
  data() {
    return {
      headers: [
        {
          text: "Trx Type",
          align: "start",
          value: "trx_type",
        },
        { text: "Date & Time", value: "updated_at" },
        { text: "Acc. No.", value: "acc_no" },
        { text: "Amount ($)", value: "amount" },
        // { text: "Acc. Type", value: "acc_type" },
        { text: "Trx. Fee ($)", value: "transaction_fee" },
        { text: "Net Amount ($)", value: "net_amount" },
        { text: "Status", value: "status" },
        // { text: "Detail", value: "detail" },
      ],
      search: "",
    };
  },

  computed: {
    ...mapState("transactions", ["recenttransactions"]),
  },

  methods: {
    ...mapActions("transactions", [
      TRANSACTION__ACTIONS.RECENTTRANSACTIONHISTORY,
    ]),

       formatMySQLDate(mysqlDate) {
    

    // Ensure the input is in the correct format
    if (!mysqlDate) return "Invalid date";

    // Replace the "T" with a space to work with the current logic
    const isoFormattedDate = mysqlDate.replace('T', ' ').split('.')[0]; // Removes milliseconds
    const [datePart, timePart] = isoFormattedDate.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':');

    // Convert 24-hour time to 12-hour time
    const hour12 = hour % 12 || 12;
    const amPm = hour >= 12 ? 'pm' : 'am';

    // Return the formatted date and time
    return `${day}.${month}.${year} - ${hour12}:${minute} ${amPm}`;
},

    getIcon(trxType) {
      if (trxType === "Depo.") return "mdi mdi-tray-arrow-down mr-1 text-gray";
      else if (trxType === "With.")
        return "mdi mdi-tray-arrow-up mr-1 text-gray";
      else return "mdi mdi-swap-horizontal mr-1 text-gray";
    },
    verifyIcon(status) {
      if (status === "Approved") return "mdi mdi-check text--green mr-1";
      else if (status === "Rejected")
        return "mdi mdi-window-close text-red mr-1";
      else return "mdi mdi-refresh mr-1 text-warning";
    },
  },

  async mounted() {
    await this[TRANSACTION__ACTIONS.RECENTTRANSACTIONHISTORY]();
  },
};
</script>

<style></style>
